<template>
  <div class="c-footer">
    <div class="c-footer-row">
      <address>
          <p>
            <small>
              Krotoski Cichy
              <br>
              ul. Radzymińska 267
              <br>
              03-643 Warszawa
              <br>
              tel.: <a href="tel:48 22 510 35 65" onclick="gtag('event', 'kliknięcie', {'event_category': 'Kontakt','event_label': 'Kliknięcie w numer telefonu - stopka','value': '1'});">48 22 510 35 65</a>
              <br>
              email: <a href="mailto:audi.salon.warszawa@krotoskicichy.com" onclick="gtag('event', 'kliknięcie', {'event_category': 'Kontakt','event_label': 'Kliknięcie w adres email - stopka','value': '1'});"> audi.salon.warszawa@krotoskicichy.com</a>
            </small>
          </p>
      </address>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style  lang="scss">
  .c-footer{
    margin-top: 5rem;
    background-color: #000;
    overflow-wrap: break-word;
    position: relative;
    width: 100%;
    padding: 1rem;
    color: #fff;
    &-row{
      margin: 0 auto;
      max-width: 1177.6px;
      width: 92%;
    }
    address{
      font-style: normal;
      font-size: 1.4rem;
    }
    a{
      color: #c03;
    }
  }
</style>
